import {
    isMobile,
    isVivaldi,
    isOpera,
    isChrome,
    isFirefox,
    isEdge,
    isDesktopSafari,
    isSamsungBrowser,
    isAndroidChrome,
    isIosChrome,
    isIosFirefox,
    isMobileSafari,
} from './userAgent'

const mobileCtaSupportArticles = {
    androidChrome: {
        en: `https://support.startpage.com/hc/en-us/articles/8623502498964-Make-Startpage-the-default-search-engine-in-Chrome-Android-`,
        de: `https://support.startpage.com/hc/de/articles/8623502498964-Startpage-in-Chrome-als-Standardsuchmaschine-Android-`,
        nl: `https://support.startpage.com/hc/nl/articles/8623502498964-Hoe-maak-ik-van-Startpage-mijn-standaardzoekmachine-in-Google-Chrome-voor-Android-`,
    },
    iosChrome: {
        en: `https://support.startpage.com/hc/en-us/articles/7444025014036-Make-Startpage-the-default-search-engine-in-Chrome-iOS-`,
        de: `https://support.startpage.com/hc/de/articles/7444025014036-Startpage-als-Standardsuchmaschine-in-Chrome-hinzufügen-iOS-`,
        nl: `https://support.startpage.com/hc/nl/articles/7444025014036-Hoe-maak-ik-van-Startpage-mijn-standaardzoekmachine-in-Google-Chrome-voor-iOS-`,
    },
    iosFirefox: {
        en: `https://support.startpage.com/hc/en-us/articles/5319839268116-Make-Startpage-the-default-search-engine-in-Firefox-iOS-`,
        de: `https://support.startpage.com/hc/de/articles/5319839268116-Startpage-im-mobilen-Firefox-als-Standardsuchmaschine-iOS-`,
        nl: `https://support.startpage.com/hc/nl/articles/5319839268116-Hoe-maak-ik-van-Startpage-mijn-standaardzoekmachine-in-Firefox-Mobile-iOS-`,
    },
    other: {
        en: `https://support.startpage.com/hc/en-us/articles/4520868432788-Make-Startpage-your-default-search-on-Firefox-mobile-Android-`,
        de: `https://support.startpage.com/hc/de/articles/4520868432788-Make-Startpage-your-default-search-on-Firefox-mobile-Android-`,
        nl: `https://support.startpage.com/hc/nl/articles/4520868432788-Make-Startpage-your-default-search-on-Firefox-mobile-Android-`,
    },
}

const getMobileSetDefaultSupportArticle = (localizationLanguage = `en`, device = `other`) => {
    const articles = mobileCtaSupportArticles[device] ?? mobileCtaSupportArticles.other
    return articles[localizationLanguage] ?? articles.en
}

const getSamsungBrowserSupportArticle = (localizationLanguage = `en`) => {
    const englishLink = `https://support.startpage.com/hc/en-us/articles/4521066066452-Make-Startpage-your-homepage-in-Samsung-Internet`
    const germanLink = `https://support.startpage.com/hc/de/articles/4521066066452-Startpage-im-Samsung-Internet-Browser-als-Startseite-Android-`
    if (localizationLanguage === `de`) {
        return germanLink
    }
    return englishLink
}

const getSetHomepageLink = (localizationLanguage = `en`) => {
    switch (localizationLanguage) {
        case `de`:
            return `https://support.startpage.com/hc/de/articles/4520979013908-Add-Startpage-to-your-home-screen-in-Safari-for-iOS`
        default:
            return `https://support.startpage.com/hc/en-us/articles/4520979013908-Add-Startpage-to-your-home-screen-in-Safari-for-iOS`
    }
}

const getDesktopSafariCtaSupportArticle = (localizationLanguage = `en`) => {
    switch (localizationLanguage) {
        case `de`:
            return `https://support.startpage.com/hc/de/articles/4480389310868-Wie-kann-ich-Startpage-als-Startseite-in-Safari-festlegen-`
        case `nl`:
            return `https://support.startpage.com/hc/nl/articles/4480389310868-Hoe-maak-ik-van-Startpage-mijn-startpagina-in-Safari-`
        default:
            return `https://support.startpage.com/hc/en-us/articles/4480389310868-Make-Startpage-your-homepage-in-Safari`
    }
}

const getDesktopVivaldiCtaSupportArticle = (localizationLanguage = `en`) => {
    switch (localizationLanguage) {
        case `de`:
            return `https://support.startpage.com/hc/de/articles/4520840695444-Startpage-als-Standardsuchmaschine-in-Vivaldi-hinzuf%C3%BCgen`
        case `nl`:
            return `https://support.startpage.com/hc/nl/articles/4520840695444-Hoe-voeg-ik-Startpage-toe-aan-Vivaldi-`
        default:
            return `https://support.startpage.com/hc/en-us/articles/4520840695444-Make-Startpage-your-default-search-engine-in-Vivaldi`
    }
}

const getOperaCtaArticleLink = (localizationLanguage = `en`) => {
    switch (localizationLanguage) {
        case `de`:
            return `https://support.startpage.com/hc/de/articles/4480499783316-Startpage-als-weitere-Suchmaschine-in-Opera-hinzuf%C3%BCgen`
        case `nl`:
            return `https://support.startpage.com/hc/nl/articles/4480499783316-Hoe-voeg-ik-Startpage-als-standaard-zoekmachine-toe-aan-Opera`
        default:
            return `https://support.startpage.com/hc/en-us/articles/4480499783316-Add-Startpage-to-Opera-as-an-other-search-engine`
    }
}

export const chromeExtensionStoreUrl = `https://chrome.google.com/webstore/detail/startpage-%E2%80%94-private-searc/fgmjlmbojbkmdpofahffgcpkhkngfpef`

const firefoxExtensionLink = `https://addons.mozilla.org/firefox/downloads/latest/startpage-private-search`

const edgeExtensionLink = `https://microsoftedge.microsoft.com/addons/detail/startpage-%E2%80%94-private-searc/jogphcaagccljpbnoddeknjjngefidmm`

const normalizeSupportLang = (lang) => (new Set([`en`, `de`, `nl`]).has(lang) ? lang : `en`)

export const getExtensionPromoCtaUrl = (lang = `en`) => {
    if (typeof window === `undefined`) {
        return null
    }
    const localizationLanguage = normalizeSupportLang(lang)
    let ctaLink = getSetHomepageLink(localizationLanguage)

    if (isMobile()) {
        if (isSamsungBrowser()) {
            ctaLink = getSamsungBrowserSupportArticle(localizationLanguage)
        } else if (isAndroidChrome()) {
            ctaLink = getMobileSetDefaultSupportArticle(localizationLanguage, `androidChrome`)
        } else if (isIosChrome()) {
            ctaLink = getMobileSetDefaultSupportArticle(localizationLanguage, `iosChrome`)
        } else if (isIosFirefox()) {
            ctaLink = getMobileSetDefaultSupportArticle(localizationLanguage, `iosFirefox`)
        } else if (isMobileSafari()) {
            ctaLink = getSetHomepageLink(localizationLanguage)
        } else {
            ctaLink = getMobileSetDefaultSupportArticle(localizationLanguage)
        }
    } else if (isVivaldi()) {
        ctaLink = getDesktopVivaldiCtaSupportArticle(localizationLanguage)
    } else if (isOpera()) {
        ctaLink = getOperaCtaArticleLink(localizationLanguage)
    } else if (isChrome()) {
        ctaLink = chromeExtensionStoreUrl
    } else if (isFirefox()) {
        ctaLink = firefoxExtensionLink
    } else if (isEdge()) {
        ctaLink = edgeExtensionLink
    } else if (isDesktopSafari()) {
        ctaLink = getDesktopSafariCtaSupportArticle(localizationLanguage)
    }
    return ctaLink
}
